import {Injectable} from '@angular/core';
import {Http, Headers} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { environment } from '../environments/environment';



@Injectable()
export class VoucherService {

	private url = environment.url;


	constructor(private http : Http){}

	
	addVoucher(FormData){
		console.log("voucher detail post = ",FormData);
		const headers = new Headers ({'Content-Type' : 'application/x-www-form-urlencoded'})
		return this.http.post(this.url + 'upload/voucherFile', FormData, {headers:headers});
	}
	
}


// WEBPACK FOOTER //
// /Users/meghneel/work/baba_frontend/src/app/voucher.service.ts